import { isElectronApp } from '#~/electron/utils.js';
import linkDeviceIris from './link-device-iris.svg';
import linkDeviceHive from './link-device-hive.svg';
import { Button } from '@studio/design-system/button';
import { Vendor, vendorName, getCurrentVendor } from '@studio/design-system/themes/vendor.js';

const LinkDeviceIconMap: Record<Vendor, string> = {
  ptzoptics: linkDeviceHive,
  iris: linkDeviceIris
};

export const Welcome = ({ onSearch }: { onSearch: () => void }) => {
  return (
    <div className='p-20'>
      <div className='flex flex-col gap-20 text-center'>
        <img
          src={LinkDeviceIconMap[getCurrentVendor()] ?? linkDeviceIris}
          className='mx-auto w-[65px]'
        />
        <LinkBridgeCopy />
        {isElectronApp() ? (
          <Button className='mx-auto' size='md' onClick={onSearch}>
            Search for Devices
          </Button>
        ) : (
          <a href='/agent/setup' target='_blank' className='mx-auto no-underline'>
            <Button size='md'>Download {vendorName()}</Button>
          </a>
        )}
      </div>
    </div>
  );
};

export const LinkBridgeCopy = () => {
  return (
    <div className='flex flex-col gap-8'>
      <h1 className='my-0 text-lg'>Link Bridge</h1>
      <p className='text-sm text-muted'>
        Link a Bridge to finish setting up your Studio. A Bridge allows {vendorName()} to access
        your local network, connect to cameras, and record video.
      </p>
    </div>
  );
};
